import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { OverlapScheduleDialogProps } from '../types';
import { InternalScheduleActionDialogActions } from '../actions';
import { PublishScheduleConfirmationConflicts } from '../../publish/confirmation/conflicts';

export const OverlapScheduleDialog = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
  disabled,
  conflicts,
  name,
  summaryDetail,
  date,
}: OverlapScheduleDialogProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'overlappingSchedules' });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <PublishScheduleConfirmationConflicts
          conflicts={conflicts}
          name={name}
          summaryDetail={summaryDetail}
          date={date}
        />
        <AlertDialogFooter>
          <InternalScheduleActionDialogActions
            type="overlap"
            onCancel={() => {
              setOpen(false);
              onCancel();
            }}
            onConfirm={() => {
              setOpen(false);
              onConfirm();
            }}
            disabled={disabled}
          />
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
